import React, { useEffect } from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";

export const ZipErrorDialog = (props) => {

    const {zipError, setZipError} = props

    useEffect(() => {
        let timeoutId;
        if (zipError) {
            timeoutId = setTimeout(() => {
                setZipError(false)
            }, 2000);
        }
        return () => {
            clearTimeout(timeoutId)

        };
    }, [zipError,setZipError]);

    return (
        <dialog
            className="dialog--temporary"
            open={zipError}
            onClose={()=>setZipError(false)}
        >
            <div className="dialog__row-container">
                <header>
                    <h2>
                    Erro ao carregar páginas de comprovantes
                    </h2>
                </header>
                <IconButton 
                    onClick={()=>setZipError(false)}
                >
                    <CloseIcon />
                </IconButton>
            </div>
        </dialog>
    );
}